import { useEffect, useState } from "react";

import { MAX_TIME } from "../consts/timeSlider";
import { generateMark } from "../utils/timeSlider";

export const useTimeSlider = (start, maxDuration) => {
  const [startTime, setStartTime] = useState(start);
  const [duration, setDuration] = useState(maxDuration);
  const [marks, setMarks] = useState([]);
  const [min, setMin] = useState(0);
  const [max, setMax] = useState(0);

  useEffect(() => {
    setMarks(generateMark(startTime, duration));
    setMin(startTime === 0 ? startTime : startTime * 100);
    setMax((startTime + duration) * 100);
  }, [startTime, duration]);

  useEffect(() => {
    if (startTime + duration > MAX_TIME) {
      setStartTime(max / 100 - duration);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [duration]);

  return [marks, min, max, setStartTime, duration, setDuration];
};
